import Camera from '@/assets/icons/Camera.svg?react';
import GiftCard from '@/assets/icons/gift_card.svg?react';
import Benefits from '@/assets/icons/admin/benefits.svg?react';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '../ui/sheet';

export function HowItWorksSheet(props: { onClose: () => void; open: boolean }) {
  return (
    <Sheet open={props.open} onOpenChange={props.onClose}>
      <SheetContent side="bottom" className="bg-primary-soft-peach px-8 pt-4 pb-7">
        <SheetHeader>
          <SheetTitle className="text-foreground py-5 text-2xl leading-8 font-normal">
            How Snap & Earn works
          </SheetTitle>
          <div className="flex gap-2">
            <Camera className="h-5 w-5" />
            <div className="flex flex-col items-start justify-start gap-1 text-xs">
              <strong>Tap Add receipt button</strong>
              <p className="text-start leading-4">Snap a photo of a receipt from any store</p>
            </div>
          </div>
          <div className="mt-2 flex gap-2">
            <GiftCard className="w-20 md:w-10" />
            <div className="flex flex-col items-start justify-start gap-1 text-xs">
              <strong>Get a gift card</strong>
              <p className="text-start leading-4">
                Upon accumulating the first 1000 points, you will receive a $5 digital gift card via
                email. Thereafter, each time you hit a points tier you will receive a digital gift
                card with the redeemable value.
              </p>
              <ul className="ml-4 list-disc">
                <li className="text-start leading-4">First 1000 points: $5</li>
                <li className="text-start leading-4">Next 1500 points: $5</li>
                <li className="text-start leading-4">Next 2000 points: $5</li>
                <li className="text-start leading-4">Next 2500 points: $5</li>
                <li className="text-start leading-4">Next 3000 points: $5</li>
              </ul>
            </div>
          </div>
          <div className="mt-2 flex gap-2">
            <Benefits className="h-5 w-5 -rotate-12" />
            <div className="flex flex-col items-start justify-start gap-1 text-xs">
              <strong>How to earn points</strong>
              <ul className="ml-4 list-disc">
                <li className="text-start leading-4">200 points for signing up</li>
                <li className="text-start leading-4">100 points per receipt</li>
                <li className="text-start leading-4">
                  20 points for every receipt that you send for review and is accepted
                </li>
                <li className="text-start leading-4">100 points for each successful referral</li>
                <li className="ml-4 text-start leading-4">
                  You win when they upload the first receipt
                </li>
              </ul>
            </div>
          </div>
        </SheetHeader>
      </SheetContent>
    </Sheet>
  );
}
